import React from 'react'
import { CobuStack } from '@cobu/ui'
import PublicProfileInfoSection from './PublicProfileInfoSection'
import PublicProfileSkills from './PublicProfileSkills'
import PublicProfileGroups from './PublicProfileGroups'
import { useFeatureFlags } from '../../hooks/useFeatureFlags';
import { Strings } from '../../constants/Strings';

type Group = { uuid: string; name: string; imageUrl?: string }

type Props = {
  user: any
  currentUser: any
  groups: Group[]
  sharedGroups: Group[]
  isOwnProfile: boolean
  canMessage?: boolean
  onGroupPress: (group: Group) => void
  onManageProfile?: () => void
  onMessage?: () => void
  onMoreOptions?: () => void
  onProfileImagePress?: () => void
}

export default function PublicProfileContent({
  user,
  currentUser,
  groups,
  sharedGroups,
  isOwnProfile,
  canMessage,
  onGroupPress,
  onManageProfile,
  onMessage,
  onMoreOptions,
  onProfileImagePress,
}: Props) {
  const { showGroups } = useFeatureFlags();
  const s = Strings.get().publicProfile.sections;
  return (
    <CobuStack gap="$0" bg="$backgroundSecondary">
      <PublicProfileInfoSection
        user={user}
        currentUser={currentUser}
        onManageProfile={onManageProfile}
        onMessage={canMessage ? onMessage : undefined}
        onMoreOptions={onMoreOptions}
        onProfileImagePress={onProfileImagePress}
        canMessage={canMessage}
      />

      <CobuStack gap="$4" bg="$backgroundSecondary" pb="$4" pt="$4">
        <PublicProfileSkills
          likesHelpingWith={user.likesHelpingWith}
          needsHelpWith={user.needsHelpWith}
        />
        {showGroups && (
          <>
            <PublicProfileGroups
              groups={sharedGroups}
              title={`${isOwnProfile ? s.groups : s.groupsInCommon} (${sharedGroups.length})`}
              onGroupPress={onGroupPress}
            />

            <PublicProfileGroups
              groups={groups}
              title={`${sharedGroups.length > 0 ? s.alsoPart : s.groups} (${groups.length})`}
              onGroupPress={onGroupPress}
            />
          </>
        )}
      </CobuStack>
    </CobuStack>
  )
}


